<div class="day-view-container" [style.height]="heightCalendar" *ngIf="calendarOptions">
  <full-calendar [options]="calendarOptions"></full-calendar>
</div>